(function () {
  document.querySelectorAll('.reinsurance-slider:not([data-flickity-ready])').forEach(function (el) {
    el.setAttribute('data-flickity-ready', 'true');
    new Flickity(el, {
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      autoPlay: 4000,
      pauseAutoPlayOnHover: true
    });
  });
})();
